/*
 * SelectItemIcon.tsx  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { Icon, ICON_SIZE } from "../Icon";

export interface ISelectItemIconProps {
	className?: string;
	name?: string;
	size?: ICON_SIZE;
}

export const SelectItemIcon: React.FC<ISelectItemIconProps> = ({ className, name, size }) => {
	const baseClass = BEM("edt-select-item-icon");

	if (className) {
		baseClass.add(className);
	}

	if (!name) {
		return null;
	}

	return <Icon name={name} size={size} className={baseClass.toClassName()} />;
};

SelectItemIcon.defaultProps = {
	size: ICON_SIZE.XSMALL
};
